import Papa from 'papaparse'
import * as XLSX from 'xlsx'
import { CompanyUserBulkCreateItem } from '@common/config/api/client'

interface UserDataRow {
  company_name: string
  role_name: string
  user_name: string
  email: string
  phone?: string
}

export const parseCSV = async (csvText: string): Promise<CompanyUserBulkCreateItem[]> => {
  return new Promise((resolve) => {
    Papa.parse<UserDataRow>(csvText, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        const parsedData = results.data
        resolve(
          parsedData.map((row) => ({
            company_name: row.company_name,
            role_name: row.role_name,
            user_name: row.user_name,
            email: row.email,
            phone: row.phone,
          })),
        )
      },
    })
  })
}

export const parseExcel = async (file: File): Promise<CompanyUserBulkCreateItem[]> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = (e: ProgressEvent<FileReader>) => {
      try {
        if (!e.target?.result) {
          reject(new Error('Failed to read file'))
          return
        }

        const data = new Uint8Array(e.target.result as ArrayBuffer)
        const workbook = XLSX.read(data, { type: 'array' })
        const firstSheetName = workbook.SheetNames[0]
        const worksheet = workbook.Sheets[firstSheetName]
        const jsonData = XLSX.utils.sheet_to_json<UserDataRow>(worksheet)

        resolve(
          jsonData.map((row) => ({
            company_name: row.company_name,
            role_name: row.role_name,
            user_name: row.user_name,
            email: row.email,
            phone: row.phone || undefined,
          })),
        )
      } catch (error) {
        reject(error)
      }
    }
    reader.onerror = (error) => reject(error)
    reader.readAsArrayBuffer(file)
  })
}
